namespace GeniuzPOS.Supplier {
    export interface CsSupplierRow {
        Id?: number;
        SupplId?: string;
        SupplName?: string;
        SupplType?: number;
        ContactName?: string;
        SupTelNo?: string;
        SupEmail?: string;
        SupplAddress?: string;
        Remark?: string;
        SupplRegName?: string;
        SupplRegAddress?: string;
        SupplTaxId?: string;
        ConsignFg?: number;
        ConsignGp?: number;
        SupplierShortName?: string;
        ReturnOutRemark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
        TelNoExt?: string;
        TelMobile?: string;
        FaxNo?: string;
        FaxExt?: string;
        CompanyCode?: string;
        BranchCode?: string;
        BranchName?: string;
        PayMethod?: string;
        CreditTerm?: number;
        TradeTerm?: string;
        AuthPerson?: string;
        AuthTel?: string;
        AuthTelExt?: string;
        AuthMobile?: string;
        AuthEmail?: string;
        SalePerson?: string;
        SaleTel?: string;
        SaleTelExt?: string;
        SaleMobile?: string;
        SaleEmail?: string;
        PurVatCode?: string;
        PurVatType?: string;
        PurVatRate?: number;
        Ctaxtype?: string;
        ErpVenderCode?: string;
        ErpVendorType?: string;
        ErpSreachName?: string;
        ErpVendorBlock?: string;
        CustBranch?: string;
        Status?: string;
    }

    export namespace CsSupplierRow {
        export const idProperty = 'SupplId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Supplier.CsSupplier';
        export const lookupKey = 'Supplier.CsSupplier';

        export function getLookup(): Q.Lookup<CsSupplierRow> {
            return Q.getLookup<CsSupplierRow>('Supplier.CsSupplier');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SupplId = "SupplId",
            SupplName = "SupplName",
            SupplType = "SupplType",
            ContactName = "ContactName",
            SupTelNo = "SupTelNo",
            SupEmail = "SupEmail",
            SupplAddress = "SupplAddress",
            Remark = "Remark",
            SupplRegName = "SupplRegName",
            SupplRegAddress = "SupplRegAddress",
            SupplTaxId = "SupplTaxId",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            SupplierShortName = "SupplierShortName",
            ReturnOutRemark = "ReturnOutRemark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName",
            TelNoExt = "TelNoExt",
            TelMobile = "TelMobile",
            FaxNo = "FaxNo",
            FaxExt = "FaxExt",
            CompanyCode = "CompanyCode",
            BranchCode = "BranchCode",
            BranchName = "BranchName",
            PayMethod = "PayMethod",
            CreditTerm = "CreditTerm",
            TradeTerm = "TradeTerm",
            AuthPerson = "AuthPerson",
            AuthTel = "AuthTel",
            AuthTelExt = "AuthTelExt",
            AuthMobile = "AuthMobile",
            AuthEmail = "AuthEmail",
            SalePerson = "SalePerson",
            SaleTel = "SaleTel",
            SaleTelExt = "SaleTelExt",
            SaleMobile = "SaleMobile",
            SaleEmail = "SaleEmail",
            PurVatCode = "PurVatCode",
            PurVatType = "PurVatType",
            PurVatRate = "PurVatRate",
            Ctaxtype = "Ctaxtype",
            ErpVenderCode = "ErpVenderCode",
            ErpVendorType = "ErpVendorType",
            ErpSreachName = "ErpSreachName",
            ErpVendorBlock = "ErpVendorBlock",
            CustBranch = "CustBranch",
            Status = "Status"
        }
    }
}
